import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/");

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "LevelLoad — Home" },
      { name: "description", content: "LevelLoad transport planning by Provision AI." },
      { property: "og:title", content: "LevelLoad — Home" },
      { property: "og:description", content: "LevelLoad transport planning by Provision AI." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
